import { gql } from '@apollo/client';

const MCT_DAILY_SUMMARIES_QUERY = gql`
  query newReportData($input: NewReportDataInput) {
    newReportData(input: $input) {
      isSuccess
      message
      reportData {
        holterProfile
      }
    }
  }
`;

export default MCT_DAILY_SUMMARIES_QUERY;
